document.addEventListener('DOMContentLoaded', function() {
	let
	overlayEl = document.querySelector('.overlay');
	
	overlayEl.addEventListener('click', el => {
		let
		overlay = el.target;

		document.body.classList.remove('modal-open');
		document.querySelectorAll('.form-select-1--selected.active').forEach(el => el.classList.remove('active'));
	});
});